import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../../components/feature/Navbar';
import Footer from '../../../components/feature/Footer';
import FloatingButtons from '../../../components/feature/FloatingButtons';

export default function BlogPost3() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <FloatingButtons />

      {/* Hero Section */}
      <section className="relative pt-32 pb-12 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <Link to="/blog" className="inline-flex items-center gap-2 text-teal-400 hover:text-teal-300 mb-6 transition-colors">
              <i className="ri-arrow-left-line"></i>
              <span className="font-medium">Blog'a Dön</span>
            </Link>
            
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-6 leading-tight">
              Yanlışlıkla Kesilen Fiber Kablo Nasıl Onarılır? Acil Müdahale
            </h1>
            
            <div className="flex flex-wrap items-center gap-4 text-slate-300">
              <div className="flex items-center gap-4 text-sm">
                <div className="flex items-center gap-1">
                  <i className="ri-calendar-line"></i>
                  <span>10 Mayıs 2024</span>
                </div>
                <div className="flex items-center gap-1">
                  <i className="ri-time-line"></i>
                  <span>6 dakika okuma</span>
                </div>
                <div className="flex items-center gap-1">
                  <i className="ri-folder-line"></i>
                  <span>Fiber Optik</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Featured Image */}
      <section className="py-12 bg-slate-50">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <div className="rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/eed68acf654b44b5969a0ca52f3ba9c5.jpg"
                alt="Yanlışlıkla Kesilen Fiber Kablo Onarımı"
                className="w-full h-auto object-cover object-top"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Article Content */}
      <article className="py-16 bg-white">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <div className="prose prose-lg max-w-none">
              
              <p className="text-xl text-slate-700 leading-relaxed mb-8 font-medium">
                İnşaat, kazı veya yol çalışmaları sırasında fiber optik kabloların yanlışlıkla kesilmesi, işletmeler için ciddi bir kriz durumudur. İstanbul, Gebze, Tuzla, Kocaeli gibi yoğun sanayi bölgelerinde bu tür kazalar sıklıkla yaşanmaktadır. Hızlı ve profesyonel müdahale, kesinti süresini minimize etmek için kritik önem taşır.
              </p>

              <div className="bg-red-50 border-l-4 border-red-500 p-6 rounded-r-xl mb-8">
                <div className="flex items-start gap-3">
                  <i className="ri-alarm-warning-line text-red-600 text-2xl mt-1"></i>
                  <div>
                    <h4 className="font-bold text-red-900 mb-2">Acil Durum!</h4>
                    <p className="text-red-800 leading-relaxed">
                      Fiber kablo kesildiğinde, internet bağlantısı, telefon hatları, güvenlik kameraları ve tüm veri iletişimi anında kesilir. Özellikle fabrika ve sanayi tesislerinde üretim durabilir, büyük maddi kayıplar oluşabilir. Hemen <strong>+90 553 716 55 61</strong> numaralı acil hattımızı arayın!
                    </p>
                  </div>
                </div>
              </div>

              <h2 className="text-3xl font-bold text-slate-900 mt-12 mb-6">Fiber Kablo Kesimi Nasıl Gerçekleşir?</h2>
              
              <p className="text-slate-700 leading-relaxed mb-6">
                Fiber optik kabloların yanlışlıkla kesilmesinin en yaygın nedenleri:
              </p>

              <div className="grid md:grid-cols-2 gap-6 mb-8">
                <div className="bg-slate-50 p-6 rounded-xl border border-slate-200">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-10 h-10 bg-orange-100 rounded-lg flex items-center justify-center">
                      <i className="ri-hammer-line text-xl text-orange-600"></i>
                    </div>
                    <h4 className="font-bold text-slate-900">İnşaat Kazıları</h4>
                  </div>
                  <p className="text-slate-700 text-sm leading-relaxed">
                    Bina temeli, altyapı veya peyzaj çalışmaları sırasında ekskavatör veya kepçe ile yeraltı kablolarının kesilmesi. En yaygın kaza nedenidir.
                  </p>
                </div>

                <div className="bg-slate-50 p-6 rounded-xl border border-slate-200">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-10 h-10 bg-orange-100 rounded-lg flex items-center justify-center">
                      <i className="ri-road-map-line text-xl text-orange-600"></i>
                    </div>
                    <h4 className="font-bold text-slate-900">Yol Çalışmaları</h4>
                  </div>
                  <p className="text-slate-700 text-sm leading-relaxed">
                    Asfalt kazıma, kanal açma veya altyapı yenileme çalışmalarında fiber hatların zarar görmesi. Belediye ve karayolları çalışmalarında sık görülür.
                  </p>
                </div>

                <div className="bg-slate-50 p-6 rounded-xl border border-slate-200">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-10 h-10 bg-orange-100 rounded-lg flex items-center justify-center">
                      <i className="ri-tools-line text-xl text-orange-600"></i>
                    </div>
                    <h4 className="font-bold text-slate-900">Mekanik Hasar</h4>
                  </div>
                  <p className="text-slate-700 text-sm leading-relaxed">
                    Ağır araç geçişi, zemin çökmesi veya bina içi tadilat çalışmalarında kablo kanallarının zarar görmesi.
                  </p>
                </div>

                <div className="bg-slate-50 p-6 rounded-xl border border-slate-200">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-10 h-10 bg-orange-100 rounded-lg flex items-center justify-center">
                      <i className="ri-flashlight-line text-xl text-orange-600"></i>
                    </div>
                    <h4 className="font-bold text-slate-900">Elektrik Çalışmaları</h4>
                  </div>
                  <p className="text-slate-700 text-sm leading-relaxed">
                    Elektrik hattı döşeme veya trafo montajı sırasında yakındaki fiber kabloların yanlışlıkla kesilmesi.
                  </p>
                </div>
              </div>

              <h2 className="text-3xl font-bold text-slate-900 mt-12 mb-6">Fiber Kablo Kesildiğinde İlk Yapılması Gerekenler</h2>

              <div className="bg-gradient-to-br from-teal-50 to-slate-50 p-8 rounded-2xl mb-8 border border-teal-100">
                <h3 className="text-xl font-bold text-slate-900 mb-4">Acil Müdahale Adımları:</h3>
                <ol className="space-y-4 text-slate-700">
                  <li className="flex items-start gap-3">
                    <span className="flex-shrink-0 w-8 h-8 bg-red-500 text-white rounded-full flex items-center justify-center font-bold text-sm">1</span>
                    <div>
                      <strong className="block mb-1">Çalışmayı Durdurun</strong>
                      <span>Kazı veya inşaat çalışmasını hemen durdurun. Daha fazla hasarı önleyin. Kablo uçlarına dokunmayın.</span>
                    </div>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="flex-shrink-0 w-8 h-8 bg-red-500 text-white rounded-full flex items-center justify-center font-bold text-sm">2</span>
                    <div>
                      <strong className="block mb-1">Acil Hattı Arayın</strong>
                      <span>7/24 acil fiber tamir hattımızı arayın: <strong className="text-teal-600">+90 553 716 55 61</strong>. Lokasyon ve durum bilgisi verin.</span>
                    </div>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="flex-shrink-0 w-8 h-8 bg-red-500 text-white rounded-full flex items-center justify-center font-bold text-sm">3</span>
                    <div>
                      <strong className="block mb-1">Alanı Koruyun</strong>
                      <span>Kesilen kablo bölgesini işaretleyin ve kordon altına alın. Kablo uçlarının daha fazla zarar görmesini engelleyin.</span>
                    </div>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="flex-shrink-0 w-8 h-8 bg-red-500 text-white rounded-full flex items-center justify-center font-bold text-sm">4</span>
                    <div>
                      <strong className="block mb-1">Fotoğraf Çekin</strong>
                      <span>Hasar bölgesinin fotoğraflarını çekin. Sigorta ve sorumluluk tespiti için önemlidir.</span>
                    </div>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="flex-shrink-0 w-8 h-8 bg-red-500 text-white rounded-full flex items-center justify-center font-bold text-sm">5</span>
                    <div>
                      <strong className="block mb-1">Ekibi Bekleyin</strong>
                      <span>Acil müdahale ekibimiz İstanbul ve çevre illerde 2 saat içinde yerinde olacaktır.</span>
                    </div>
                  </li>
                </ol>
              </div>

              <h2 className="text-3xl font-bold text-slate-900 mt-12 mb-6">Acil Fiber Kablo Onarım Süreci</h2>

              <h3 className="text-2xl font-bold text-slate-900 mt-8 mb-4">1. Yerinde Keşif ve Hasar Değerlendirmesi</h3>
              
              <p className="text-slate-700 leading-relaxed mb-6">
                Ekibimiz olay yerine ulaştığında ilk olarak:
              </p>

              <ul className="space-y-3 text-slate-700 mb-6 ml-6">
                <li className="flex items-start gap-3">
                  <span className="text-teal-500 font-bold">•</span>
                  <span>Kesilen kablonun tipi belirlenir (single mode, multi mode, fiber sayısı)</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-teal-500 font-bold">•</span>
                  <span>Hasar derecesi tespit edilir (tam kesik, kısmi hasar, ezilme)</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-teal-500 font-bold">•</span>
                  <span>Kablo uçlarının durumu kontrol edilir</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-teal-500 font-bold">•</span>
                  <span>Gerekli malzeme ve ekipman listesi çıkarılır</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-teal-500 font-bold">•</span>
                  <span>Tahmini tamir süresi ve maliyet bilgisi verilir</span>
                </li>
              </ul>

              <h3 className="text-2xl font-bold text-slate-900 mt-8 mb-4">2. Kablo Uçlarının Hazırlanması</h3>
              
              <p className="text-slate-700 leading-relaxed mb-6">
                Kesilen kablo uçları temizlenir ve ek için hazırlanır:
              </p>

              <div className="bg-white border-2 border-slate-200 p-6 rounded-xl mb-6">
                <ul className="space-y-3 text-slate-700">
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-teal-500 mt-1"></i>
                    <span>Hasar görmüş kablo bölümü kesilerek çıkarılır (genellikle 50-100 cm)</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-teal-500 mt-1"></i>
                    <span>Kablo dış kılıfı ve koruyucu katmanlar soyulur</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-teal-500 mt-1"></i>
                    <span>Her bir fiber ayrı ayrı tanımlanır ve etiketlenir</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-teal-500 mt-1"></i>
                    <span>Fiber uçları temizlenir ve precision cleaver ile kesilir</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-teal-500 mt-1"></i>
                    <span>Splice closure (ek kutusu) hazırlanır</span>
                  </li>
                </ul>
              </div>

              <h3 className="text-2xl font-bold text-slate-900 mt-8 mb-4">3. Fusion Splicing İşlemi</h3>
              
              <p className="text-slate-700 leading-relaxed mb-6">
                Her bir fiber çifti <Link to="/blog/fusion-splicing-nedir" className="text-teal-600 hover:text-teal-700 font-semibold">fusion splicing</Link> yöntemi ile kaynaştırılır:
              </p>

              <div className="grid md:grid-cols-2 gap-6 mb-8">
                <div className="bg-gradient-to-br from-teal-50 to-slate-50 p-6 rounded-xl border border-teal-100">
                  <div className="w-12 h-12 bg-teal-500 text-white rounded-xl flex items-center justify-center mb-4">
                    <i className="ri-flashlight-line text-2xl"></i>
                  </div>
                  <h4 className="font-bold text-slate-900 mb-2">Otomatik Hizalama</h4>
                  <p className="text-slate-700 text-sm leading-relaxed">
                    Fusion splicer cihazı fiber uçlarını mikron hassasiyetinde hizalar. Core alignment teknolojisi ile mükemmel ek sağlanır.
                  </p>
                </div>

                <div className="bg-gradient-to-br from-teal-50 to-slate-50 p-6 rounded-xl border border-teal-100">
                  <div className="w-12 h-12 bg-teal-500 text-white rounded-xl flex items-center justify-center mb-4">
                    <i className="ri-fire-line text-2xl"></i>
                  </div>
                  <h4 className="font-bold text-slate-900 mb-2">Kaynaştırma</h4>
                  <p className="text-slate-700 text-sm leading-relaxed">
                    Elektrik arkı ile 2000°C sıcaklıkta fiberler kaynaştırılır. İşlem 10-15 saniye sürer ve kalıcı bağlantı oluşur.
                  </p>
                </div>

                <div className="bg-gradient-to-br from-teal-50 to-slate-50 p-6 rounded-xl border border-teal-100">
                  <div className="w-12 h-12 bg-teal-500 text-white rounded-xl flex items-center justify-center mb-4">
                    <i className="ri-line-chart-line text-2xl"></i>
                  </div>
                  <h4 className="font-bold text-slate-900 mb-2">Kayıp Ölçümü</h4>
                  <p className="text-slate-700 text-sm leading-relaxed">
                    Cihaz otomatik olarak ek kaybını ölçer. Tipik değer 0.02-0.05 dB. Yüksek kayıp durumunda ek tekrarlanır.
                  </p>
                </div>

                <div className="bg-gradient-to-br from-teal-50 to-slate-50 p-6 rounded-xl border border-teal-100">
                  <div className="w-12 h-12 bg-teal-500 text-white rounded-xl flex items-center justify-center mb-4">
                    <i className="ri-shield-line text-2xl"></i>
                  </div>
                  <h4 className="font-bold text-slate-900 mb-2">Koruma</h4>
                  <p className="text-slate-700 text-sm leading-relaxed">
                    Heat shrink sleeve ile ek noktası korunur. Mekanik dayanım ve su geçirmezlik sağlanır.
                  </p>
                </div>
              </div>

              <h3 className="text-2xl font-bold text-slate-900 mt-8 mb-4">4. OTDR Test ve Doğrulama</h3>
              
              <p className="text-slate-700 leading-relaxed mb-6">
                Tüm ekler tamamlandıktan sonra <Link to="/blog/otdr-testi-nedir" className="text-teal-600 hover:text-teal-700 font-semibold">OTDR testi</Link> yapılır:
              </p>

              <div className="bg-slate-50 p-6 rounded-xl mb-8 border border-slate-200">
                <ul className="space-y-3 text-slate-700">
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-teal-500 mt-1"></i>
                    <span>Her fiber için OTDR trace alınır</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-teal-500 mt-1"></i>
                    <span>Ek kalitesi ve kayıp değerleri doğrulanır</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-teal-500 mt-1"></i>
                    <span>Toplam hat kaybı ölçülür</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-teal-500 mt-1"></i>
                    <span>Başka hasar noktası olmadığı kontrol edilir</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-teal-500 mt-1"></i>
                    <span>Test raporu hazırlanır ve müşteriye teslim edilir</span>
                  </li>
                </ul>
              </div>

              <h3 className="text-2xl font-bold text-slate-900 mt-8 mb-4">5. Sistem Devreye Alma</h3>
              
              <p className="text-slate-700 leading-relaxed mb-6">
                Test sonuçları onaylandıktan sonra:
              </p>

              <ul className="space-y-3 text-slate-700 mb-6 ml-6">
                <li className="flex items-start gap-3">
                  <span className="text-teal-500 font-bold">•</span>
                  <span>Aktif ekipmanlar bağlanır</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-teal-500 font-bold">•</span>
                  <span>İnternet ve veri bağlantısı test edilir</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-teal-500 font-bold">•</span>
                  <span>Tüm sistemlerin çalıştığı doğrulanır</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-teal-500 font-bold">•</span>
                  <span>Müşteriye teslim tutanağı düzenlenir</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-teal-500 font-bold">•</span>
                  <span>2 yıl garanti belgesi verilir</span>
                </li>
              </ul>

              <h2 className="text-3xl font-bold text-slate-900 mt-12 mb-6">Acil Müdahale Süremiz</h2>

              <div className="grid md:grid-cols-3 gap-6 mb-8">
                <div className="text-center p-6 bg-gradient-to-br from-teal-50 to-slate-50 rounded-xl border border-teal-100">
                  <div className="w-16 h-16 bg-teal-500 text-white rounded-2xl flex items-center justify-center mx-auto mb-4 text-3xl font-bold">
                    &lt;2
                  </div>
                  <h4 className="font-bold text-slate-900 mb-2">Saat</h4>
                  <p className="text-slate-600 text-sm">
                    <Link to="/bolgeler/istanbul-avrupa" className="hover:text-teal-600">İstanbul</Link>, <Link to="/bolgeler/gebze" className="hover:text-teal-600">Gebze</Link>, <Link to="/bolgeler/tuzla" className="hover:text-teal-600">Tuzla</Link> bölgelerinde yerinde
                  </p>
                </div>

                <div className="text-center p-6 bg-gradient-to-br from-teal-50 to-slate-50 rounded-xl border border-teal-100">
                  <div className="w-16 h-16 bg-teal-500 text-white rounded-2xl flex items-center justify-center mx-auto mb-4 text-3xl font-bold">
                    4-8
                  </div>
                  <h4 className="font-bold text-slate-900 mb-2">Saat</h4>
                  <p className="text-slate-600 text-sm">
                    Ortalama tamir süresi (fiber sayısına göre değişir)
                  </p>
                </div>

                <div className="text-center p-6 bg-gradient-to-br from-teal-50 to-slate-50 rounded-xl border border-teal-100">
                  <div className="w-16 h-16 bg-teal-500 text-white rounded-2xl flex items-center justify-center mx-auto mb-4">
                    <i className="ri-24-hours-line text-3xl"></i>
                  </div>
                  <h4 className="font-bold text-slate-900 mb-2">7/24</h4>
                  <p className="text-slate-600 text-sm">
                    Hafta sonu ve tatil günleri dahil kesintisiz hizmet
                  </p>
                </div>
              </div>

              <h2 className="text-3xl font-bold text-slate-900 mt-12 mb-6">Fiber Kablo Kesimini Önleme Yöntemleri</h2>

              <p className="text-slate-700 leading-relaxed mb-6">
                Gelecekte benzer kazaların önlenmesi için:
              </p>

              <div className="space-y-6 mb-8">
                <div className="bg-slate-50 p-6 rounded-xl border border-slate-200">
                  <h4 className="font-bold text-slate-900 mb-3 flex items-center gap-2">
                    <i className="ri-map-pin-line text-teal-500 text-xl"></i>
                    Kablo Haritası Oluşturma
                  </h4>
                  <p className="text-slate-700 text-sm leading-relaxed">
                    Tüm fiber kablo güzergahları detaylı olarak haritalanmalı ve belgelenmelidir. GPS koordinatları, derinlik bilgileri ve fotoğraflar kaydedilmelidir.
                  </p>
                </div>

                <div className="bg-slate-50 p-6 rounded-xl border border-slate-200">
                  <h4 className="font-bold text-slate-900 mb-3 flex items-center gap-2">
                    <i className="ri-alert-line text-teal-500 text-xl"></i>
                    Uyarı İşaretleri
                  </h4>
                  <p className="text-slate-700 text-sm leading-relaxed">
                    Fiber kablo güzergahları üzerine uyarı levhaları ve işaret bantları yerleştirilmelidir. Yeraltı kablolar için uyarı şeridi kullanılmalıdır.
                  </p>
                </div>

                <div className="bg-slate-50 p-6 rounded-xl border border-slate-200">
                  <h4 className="font-bold text-slate-900 mb-3 flex items-center gap-2">
                    <i className="ri-shield-line text-teal-500 text-xl"></i>
                    Koruyucu Boru Kullanımı
                  </h4>
                  <p className="text-slate-700 text-sm leading-relaxed">
                    Fiber kablolar HDPE boru içinde döşenmelidir. Özellikle yol geçişleri ve riskli bölgelerde çelik boru kullanılmalıdır.
                  </p>
                </div>

                <div className="bg-slate-50 p-6 rounded-xl border border-slate-200">
                  <h4 className="font-bold text-slate-900 mb-3 flex items-center gap-2">
                    <i className="ri-search-line text-teal-500 text-xl"></i>
                    Kazı Öncesi Araştırma
                  </h4>
                  <p className="text-slate-700 text-sm leading-relaxed">
                    Her kazı çalışması öncesi altyapı haritaları kontrol edilmeli ve gerekirse kablo dedektörü ile tarama yapılmalıdır.
                  </p>
                </div>
              </div>

              <h2 className="text-3xl font-bold text-slate-900 mt-12 mb-6">Sigorta ve Sorumluluk</h2>

              <div className="bg-amber-50 border-l-4 border-amber-500 p-6 rounded-r-xl mb-8">
                <div className="flex items-start gap-3">
                  <i className="ri-information-line text-amber-600 text-2xl mt-1"></i>
                  <div>
                    <h4 className="font-bold text-amber-900 mb-2">Önemli Bilgi:</h4>
                    <p className="text-amber-800 leading-relaxed mb-3">
                      Fiber kablo kesimi durumunda sorumluluk genellikle kazıyı yapan firmaya aittir. Tamir maliyeti ve kesinti süresince oluşan kayıplar tazmin edilebilir.
                    </p>
                    <ul className="space-y-2 text-amber-800 text-sm">
                      <li className="flex items-start gap-2">
                        <span>•</span>
                        <span>Olay yeri fotoğrafları çekin</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <span>•</span>
                        <span>Tutanak tutun ve imzalatın</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <span>•</span>
                        <span>Tamir faturası ve test raporlarını saklayın</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <span>•</span>
                        <span>Kesinti süresini ve etkilerini belgeleyin</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <h2 className="text-3xl font-bold text-slate-900 mt-12 mb-6">Sık Sorulan Sorular</h2>

              <div className="space-y-4 mb-12">
                <details className="bg-slate-50 p-6 rounded-xl border border-slate-200 group">
                  <summary className="font-bold text-slate-900 cursor-pointer list-none flex items-center justify-between">
                    <span>Kesilen fiber kablo ne kadar sürede onarılır?</span>
                    <i className="ri-arrow-down-s-line text-2xl text-teal-500 group-open:rotate-180 transition-transform"></i>
                  </summary>
                  <p className="text-slate-700 mt-4 leading-relaxed">
                    Tamir süresi fiber sayısına ve hasar derecesine bağlıdır. 12 fiber kablo için ortalama 4-6 saat, 48 fiber kablo için 8-12 saat sürebilir. Acil müdahale ekibimiz İstanbul ve çevre illerde 2 saat içinde yerinde olup, en kısa sürede sistemi devreye alır.
                  </p>
                </details>

                <details className="bg-slate-50 p-6 rounded-xl border border-slate-200 group">
                  <summary className="font-bold text-slate-900 cursor-pointer list-none flex items-center justify-between">
                    <span>Fiber kablo tamiri maliyeti ne kadardır?</span>
                    <i className="ri-arrow-down-s-line text-2xl text-teal-500 group-open:rotate-180 transition-transform"></i>
                  </summary>
                  <p className="text-slate-700 mt-4 leading-relaxed">
                    Maliyet fiber sayısı, kablo tipi, erişim zorluğu ve çalışma saatine göre değişir. Acil müdahale hizmetlerinde ek ücret uygulanabilir. Ücretsiz keşif hizmetimiz ile yerinde inceleme yapıp, detaylı fiyat teklifi sunuyoruz.
                  </p>
                </details>

                <details className="bg-slate-50 p-6 rounded-xl border border-slate-200 group">
                  <summary className="font-bold text-slate-900 cursor-pointer list-none flex items-center justify-between">
                    <span>Tamir sonrası performans kaybı olur mu?</span>
                    <i className="ri-arrow-down-s-line text-2xl text-teal-500 group-open:rotate-180 transition-transform"></i>
                  </summary>
                  <p className="text-slate-700 mt-4 leading-relaxed">
                    Profesyonel fusion splicing ile yapılan tamir, orijinal kablo performansını korur. Ek kaybı çok düşüktür (0.02-0.05 dB) ve sistem performansını etkilemez. OTDR test raporu ile ek kalitesi belgelenir.
                  </p>
                </details>

                <details className="bg-slate-50 p-6 rounded-xl border border-slate-200 group">
                  <summary className="font-bold text-slate-900 cursor-pointer list-none flex items-center justify-between">
                    <span>Geçici çözüm mümkün mü?</span>
                    <i className="ri-arrow-down-s-line text-2xl text-teal-500 group-open:rotate-180 transition-transform"></i>
                  </summary>
                  <p className="text-slate-700 mt-4 leading-relaxed">
                    Kritik durumlarda geçici olarak yedek kablo çekilebilir veya kablosuz köprü kurulabilir. Ancak kalıcı çözüm için fiber tamir şarttır. Geçici çözümler genellikle düşük performans ve güvenilirlik sunar.
                  </p>
                </details>
              </div>

            </div>

            {/* CTA Section */}
            <div className="mt-16 p-8 bg-gradient-to-br from-red-600 to-red-700 rounded-2xl text-center">
              <div className="flex items-center justify-center gap-3 mb-4">
                <i className="ri-alarm-warning-line text-4xl text-white animate-pulse"></i>
                <h3 className="text-3xl font-bold text-white">
                  Acil Fiber Kablo Arızası!
                </h3>
              </div>
              <p className="text-white text-lg mb-6">
                7/24 acil müdahale ekibimiz 2 saat içinde yerinde!
              </p>
              <div className="flex flex-wrap items-center justify-center gap-4">
                <a
                  href="tel:+905537165561"
                  className="px-8 py-4 bg-white hover:bg-slate-100 text-red-600 font-bold rounded-xl transition-all duration-300 hover:shadow-2xl whitespace-nowrap cursor-pointer text-lg"
                >
                  <i className="ri-phone-line mr-2"></i>
                  +90 553 716 55 61 - ACİL HAT
                </a>
                <a
                  href="https://wa.me/908505551234"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="px-8 py-4 bg-green-500 hover:bg-green-600 text-white font-semibold rounded-xl transition-all duration-300 hover:shadow-lg whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-whatsapp-line mr-2"></i>
                  WhatsApp Destek
                </a>
              </div>
            </div>

            {/* İlgili Hizmetler */}
            <div className="mt-12">
              <h3 className="text-2xl font-bold text-slate-900 mb-6">İlgili Hizmetlerimiz</h3>
              <div className="grid md:grid-cols-2 gap-4">
                <Link to="/fiber-hizmetleri/acil-servis" className="group flex items-center gap-4 p-5 bg-teal-50 border border-teal-200 rounded-xl hover:bg-teal-500 hover:border-teal-500 transition-all duration-300">
                  <div className="w-12 h-12 flex items-center justify-center bg-teal-500 group-hover:bg-white rounded-xl flex-shrink-0">
                    <i className="ri-alarm-warning-line text-2xl text-white group-hover:text-teal-500"></i>
                  </div>
                  <div>
                    <div className="font-bold text-slate-900 group-hover:text-white">7/24 Acil Fiber Servisi</div>
                    <div className="text-sm text-slate-600 group-hover:text-teal-100">2 saat içinde yerinde acil müdahale</div>
                  </div>
                  <i className="ri-arrow-right-line ml-auto text-teal-500 group-hover:text-white"></i>
                </Link>
                <Link to="/fiber-hizmetleri/fiber-kablo-tamiri" className="group flex items-center gap-4 p-5 bg-teal-50 border border-teal-200 rounded-xl hover:bg-teal-500 hover:border-teal-500 transition-all duration-300">
                  <div className="w-12 h-12 flex items-center justify-center bg-teal-500 group-hover:bg-white rounded-xl flex-shrink-0">
                    <i className="ri-tools-line text-2xl text-white group-hover:text-teal-500"></i>
                  </div>
                  <div>
                    <div className="font-bold text-slate-900 group-hover:text-white">Fiber Kablo Tamiri</div>
                    <div className="text-sm text-slate-600 group-hover:text-teal-100">Profesyonel fiber optik onarım</div>
                  </div>
                  <i className="ri-arrow-right-line ml-auto text-teal-500 group-hover:text-white"></i>
                </Link>
                <Link to="/fiber-hizmetleri/otdr-test" className="group flex items-center gap-4 p-5 bg-teal-50 border border-teal-200 rounded-xl hover:bg-teal-500 hover:border-teal-500 transition-all duration-300">
                  <div className="w-12 h-12 flex items-center justify-center bg-teal-500 group-hover:bg-white rounded-xl flex-shrink-0">
                    <i className="ri-line-chart-line text-2xl text-white group-hover:text-teal-500"></i>
                  </div>
                  <div>
                    <div className="font-bold text-slate-900 group-hover:text-white">OTDR Test Hizmeti</div>
                    <div className="text-sm text-slate-600 group-hover:text-teal-100">Arıza tespiti ve fiber analizi</div>
                  </div>
                  <i className="ri-arrow-right-line ml-auto text-teal-500 group-hover:text-white"></i>
                </Link>
                <Link to="/fiber-hizmetleri/fiber-sonlandirma" className="group flex items-center gap-4 p-5 bg-teal-50 border border-teal-200 rounded-xl hover:bg-teal-500 hover:border-teal-500 transition-all duration-300">
                  <div className="w-12 h-12 flex items-center justify-center bg-teal-500 group-hover:bg-white rounded-xl flex-shrink-0">
                    <i className="ri-flashlight-line text-2xl text-white group-hover:text-teal-500"></i>
                  </div>
                  <div>
                    <div className="font-bold text-slate-900 group-hover:text-white">Fusion Splicing & Sonlandırma</div>
                    <div className="text-sm text-slate-600 group-hover:text-teal-100">Kalıcı fiber ek ve onarım</div>
                  </div>
                  <i className="ri-arrow-right-line ml-auto text-teal-500 group-hover:text-white"></i>
                </Link>
              </div>
            </div>

            {/* Related Articles */}
            <div className="mt-16">
              <h3 className="text-2xl font-bold text-slate-900 mb-6">İlgili Makaleler</h3>
              <div className="grid md:grid-cols-3 gap-6">
                <Link to="/blog/fiber-optik-kablo-tamiri-nasil-yapilir" className="group">
                  <div className="bg-slate-50 rounded-xl p-6 border border-slate-200 hover:border-teal-500 transition-all hover:shadow-lg">
                    <div className="w-12 h-12 bg-teal-100 rounded-xl flex items-center justify-center mb-4 group-hover:bg-teal-500 transition-colors">
                      <i className="ri-tools-line text-2xl text-teal-600 group-hover:text-white"></i>
                    </div>
                    <h4 className="font-bold text-slate-900 mb-2 group-hover:text-teal-600">Fiber Kablo Tamiri</h4>
                    <p className="text-slate-600 text-sm">Profesyonel fiber optik kablo tamir rehberi</p>
                  </div>
                </Link>

                <Link to="/blog/fusion-splicing-nedir" className="group">
                  <div className="bg-slate-50 rounded-xl p-6 border border-slate-200 hover:border-teal-500 transition-all hover:shadow-lg">
                    <div className="w-12 h-12 bg-teal-100 rounded-xl flex items-center justify-center mb-4 group-hover:bg-teal-500 transition-colors">
                      <i className="ri-flashlight-line text-2xl text-teal-600 group-hover:text-white"></i>
                    </div>
                    <h4 className="font-bold text-slate-900 mb-2 group-hover:text-teal-600">Fusion Splicing</h4>
                    <p className="text-slate-600 text-sm">Fiber optik kaynaklı ek teknolojisi</p>
                  </div>
                </Link>

                <Link to="/blog/otdr-testi-nedir" className="group">
                  <div className="bg-slate-50 rounded-xl p-6 border border-slate-200 hover:border-teal-500 transition-all hover:shadow-lg">
                    <div className="w-12 h-12 bg-teal-100 rounded-xl flex items-center justify-center mb-4 group-hover:bg-teal-500 transition-colors">
                      <i className="ri-line-chart-line text-2xl text-teal-600 group-hover:text-white"></i>
                    </div>
                    <h4 className="font-bold text-slate-900 mb-2 group-hover:text-teal-600">OTDR Testi</h4>
                    <p className="text-slate-600 text-sm">Fiber optik arıza tespit yöntemi</p>
                  </div>
                </Link>
              </div>
            </div>

          </div>
        </div>
      </article>

      <Footer />
    </div>
  );
}